unit Utils;
{

/* Initial. */

}
interface

uses StrUtils,
     WEBLib.Graphics;

{uses Winapi.Windows, Winapi.Messages,
     System.SysUtils, System.StrUtils, System.Classes,
     Vcl.Buttons, Vcl.Controls, Vcl.Dialogs, Vcl.ExtCtrls, Vcl.Forms, Vcl.Graphics, Vcl.StdCtrls, Vcl.Grids,
     Math, IdExplicitTLSClientServerBase, IdFTP, IdFTPCommon, IdSSLOpenSSL, IdSSLOpenSSLHeaders;}


function EncodeBase64(const String_Text: String): String;
function GetColor(const String_Name: String): TColor;
{function StringToHex(S: AnsiString): AnsiString;
function HexToString(S: AnsiString): AnsiString;
function Encrypt(Decrypt: AnsiString): AnsiString;
function Decrypt(Encrypt: AnsiString): String;
function FTP(const Char_Action: Char; const String_Path: String; const String_FileName: String): Boolean;
function MessageDlgEx(Caption, Msg: string; AType: TMsgDlgType;
                      AButtons: array of string;
                      DefBtn, CanBtn: Integer; iWidth:integer=450;bCourier:boolean=False): Word;
procedure AutoSizeColsStringGrid(var StringGrid_AutoSize: TStringGrid);

const
  ConstantString_Key = 'DThhcuR*Nq98SgC!3!b9X?M+NQMwGmjY';}

implementation

function EncodeBase64(const String_Text: String): String;
begin
  asm
    Result = btoa(String_Text);
  end;
end;

{uses
 Config;}

function GetColor(const String_Name: String): TColor;
var Byte_Red: Byte;
    Byte_Green: Byte;
    Byte_Blue: Byte;
begin
  if not ContainsText(String_Name, '_12') and not ContainsText(String_Name, '_16') and (String_Name <> 'Label_Function') and (String_Name <> 'Gray') and not ContainsText(String_Name, 'Green') and (String_Name <> 'Red')  then
  begin
    Byte_Red := 0;
    Byte_Green := 183;
    Byte_Blue := 239;
  end
  else if ContainsText(String_Name, '_12') then
  begin
    Byte_Red := 255;
    Byte_Green := 242;
    Byte_Blue := 0;
  end
  else if (String_Name = 'Label_Function') or (ContainsText(String_Name, '_16')) then
  begin
    Byte_Red := 237;
    Byte_Green := 28;
    Byte_Blue := 36;
  end
  else if (String_Name = 'Gray') then
  begin
    Byte_Red := 223;
    Byte_Green := 227;
    Byte_Blue := 232;
  end
  else if (String_Name = 'Green') then
  begin
    Byte_Red := 0;
    Byte_Green := 255;
    Byte_Blue := 0;
  end
  else if (String_Name = 'DarkGreen') then
  begin
    Byte_Red := 35;
    Byte_Green := 184;
    Byte_Blue := 79;
  end
  else if (String_Name = 'Red') then
  begin
    Byte_Red := 255;
    Byte_Green := 0;
    Byte_Blue := 0;
  end
  else
  begin
    Byte_Red := 0;
    Byte_Green := 0;
    Byte_Blue := 0;
  end;

  GetColor := RGB(Byte_Red, Byte_Green, Byte_Blue);
end;

{function StringToHex(S: AnsiString): AnsiString;
var
	i: integer;

begin
  Result := '';

  // Go throught every single characters, and convert them
  // to hexadecimal...
	for i := 1 to Length( S ) do
  	Result := Result + IntToHex( byte( S[i] ), 2 );
end;

function HexToString(S: AnsiString): AnsiString;
var
	i: integer;

begin
  Result := '';

  // Go throught every single hexadecimal characters, and convert
  // them to ASCII characters...
  for i := 1 to Length( S ) do
  begin
    // Only process chunk of 2 digit Hexadecimal...
  	if ((i mod 2) = 1) then
	  	Result := Result + AnsiChar( StrToInt( '0x' + Copy( S, i, 2 )));
  end;
end;

(*******************************************************************************
   This routine will encrypt text using a TStringStream... Once the text is
   encrypted it will be converted to hexadecimals to assure visibility of the
   text. If the text is not converted, it might not be visible since their might
   by null characters  within the encrypted string therefore text will be lost.

   If the encrypted text is saved to a memory variable or file it is not
   necessary convert it to hexa...
*******************************************************************************)
function Encrypt(Decrypt: AnsiString): AnsiString;
var
  Source: TMemoryStream;
  Dest: TMemoryStream;
  Key: TAESKey128;
  Size: Integer;
  str: AnsiString;
begin
  // Encryption
  Source := TMemoryStream.Create();
  Dest   := TMemoryStream.Create();

  try
    // Save data to memory stream...
    Source.Write(PAnsiChar(AnsiString(Decrypt))^, length(Decrypt));
    Source.Position := 0;
    Size := Source.Size;
    Dest.WriteBuffer(Size, SizeOf(Size));

    // Prepare key...
    FillChar( Key, SizeOf(Key), 0 );
    Move(PAnsiChar(AnsiString(ConstantString_Key))^, Key, Min( SizeOf(Key), Length(ConstantString_Key)));

    // Start encryption...
    EncryptAESStreamECB(Source, 0, Key, Dest);

    // Convert encrypted text using hexadecimals...
    Dest.Position := 0;
    setlength(str, Dest.Size);
    Dest.Read(PAnsiChar(str)^, Dest.Size);

    str := StringToHex(str);
  except
    str := '';
  end;

  Source.Free;
  Dest.Free;

  Encrypt := str;
end;

function Decrypt(Encrypt: AnsiString): String;
var
  Source: TMemoryStream;
  Dest: TMemoryStream;
  Key: TAESKey128;
  Size: integer;
  str: AnsiString;
begin
  // Decrypt := Encrypt;
  // Exit;

  // Convert hexadecimal to a strings before decrypting...
  Source := TMemoryStream.Create();
  Dest   := TMemoryStream.Create();

  try
    str := HexToString(Encrypt);
    Source.Write(PAnsiChar(str)^, length(str));
    Source.Position := 0;
  // Start decryption...
    Size := Source.Size;
    Source.ReadBuffer(Size, SizeOf(Size));

    // Prepare key...
    FillChar(Key, SizeOf(Key), 0);
    Move(PAnsiChar(AnsiString(ConstantString_Key))^, Key, Min(SizeOf(Key), Length(ConstantString_Key)));

    // Decrypt now...
    DecryptAESStreamECB(Source, Source.Size - Source.Position, Key, Dest);

    // Display unencrypted text...
    Dest.position := 0;
    SetLength(str, dest.Size);
    Dest.Read(PAnsiChar(str)^, dest.Size);
  except
    str := '';
  end;

  Source.Free;
  Dest.Free;

  Decrypt := String(Trim(str));
end;

// D --> Download, U --> Upload, R --> Remove.
function FTP(const Char_Action: Char; const String_Path: String; const String_FileName: String): Boolean;
var
  IdSSLIOHandlerSocketOpenSSL_File: TIdSSLIOHandlerSocketOpenSSL;
  IdFTP_File: TIdFTP;
  Boolean_Ok: Boolean;
begin
  IdFTP_File := TIdFTP.Create(nil);

  IdSSLIOHandlerSocketOpenSSL_File := TIdSSLIOHandlerSocketOpenSSL.Create(nil);
  IdSSLIOHandlerSocketOpenSSL_File.SSLOptions.Mode := sslmClient;
  IdSSLIOHandlerSocketOpenSSL_File.SSLOptions.Method := sslvTLSv1_2;
  IdSSLIOHandlerSocketOpenSSL_File.SSLOptions.VerifyDepth := 0;

  IdFTP_File.IOHandler := IdSSLIOHandlerSocketOpenSSL_File;
  IdFTP_File.UseTLS := utUseExplicitTLS;
  IdFTP_File.Host := String_FTPServer;
  IdFTP_File.Username := String_FTPUserName;
  IdFTP_File.Password :=  String_FTPPassWord;

  Boolean_Ok := True;

  try
    try
      IdFTP_File.Connect;
      IdFTP_File.DataPortProtection := ftpdpsPrivate;
      IdFTP_File.Passive := True;
      IdFTP_File.ChangeDir(String_Path);

      try
        if Char_Action = 'D' then
          // Get file from FTP server and save.
          IdFTP_File.Get(String_FileName, GetCurrentDir + '\Files\' + String_FileName, True, False)
        else if Char_Action = 'U' then
          // Put file on FTP server.
          IdFTP_File.Put(GetCurrentDir + '\Files\' + String_FileName, String_FileName, False)
        else if Char_Action = 'R' then
          // Delete file from FTP server.
          IdFTP_File.Delete(String_FileName)
      except
        on E: Exception do
        begin
          ShowMessage('Exception message = ' + E.Message);

          Boolean_Ok := False;
        end;
      end;
    except
      on E: Exception do
      begin
        ShowMessage('Exception message = ' + E.Message);

        ShowMessage(WhichFailedToLoad());

        Boolean_Ok := False;
      end;
    end;
  finally
    IdFTP_File.Disconnect;
    IdFTP_File.Free;
    IdSSLIOHandlerSocketOpenSSL_File.Free;
  end;

  FTP := Boolean_Ok;
end;

function MessageDlgEx(Caption, Msg: string; AType: TMsgDlgType;
                      AButtons: array of string;
                      DefBtn, CanBtn: Integer; iWidth:integer=450;bCourier:boolean=False): Word;
const
  icMin=50;
  icButtonHeight=25;
  icInterspace=10;
  icButtonResultStart=100;
  icFirstButtonReturnValue=1;
var
  I, iButtonWidth, iAllButtonsWidth,
  iIconWidth,iIconHeight:Integer;
  LabelText:String;
  Frm: TForm;
  Lbl: TLabel;
  Btn: TBitBtn;
  Glyph: TImage;
  FIcon: TIcon;
  Rect:TRect;
  Caption_ca:Array[0..2000] of Char;
begin
  Frm := TForm.Create(Application);
  Frm.BorderStyle := bsDialog;
  Frm.BorderIcons := [biSystemMenu];
  Frm.FormStyle := fsStayOnTop;
  Frm.Height := 185;
  Frm.Width := iWidth;
  Frm.Position := poScreenCenter;
  Frm.Caption := Caption;
  Frm.Font.Style:=[];
  Frm.Scaled:=False;

  Glyph := TImage.Create(Frm);
  Glyph.Name := 'Image';
  Glyph.Parent := Frm;

  FIcon := TIcon.Create;
  try
    if AType = mtConfirmation then
      FIcon.Handle := LoadIcon(0, IDI_QUESTION)
    else if AType = mtError then
      FIcon.Handle := LoadIcon(0, IDI_ERROR)
    else if AType = mtInformation then
      FIcon.Handle := LoadIcon(0, IDI_INFORMATION)
    else if AType = mtWarning then
      FIcon.Handle := LoadIcon(0, IDI_EXCLAMATION)
    else
      FIcon.Handle := LoadIcon(0, nil);

      iIconWidth:=FIcon.Width;
      iIconHeight:=FIcon.Height;
      Glyph.Picture.Graphic := FIcon;
      Glyph.BoundsRect := Bounds(icInterspace, icInterspace, FIcon.Width, FIcon.Height);
    finally
      FIcon.Free;
    end;

  iButtonWidth := 0;
  for I := 0 to High(AButtons) do
    iButtonWidth := Max(iButtonWidth, frm.Canvas.TextWidth(AButtons[I]));

  iButtonWidth := iButtonWidth + 18;

  If iButtonWidth<icMin Then
    iButtonWidth:=icMin;

  iAllButtonsWidth := iButtonWidth * (High(AButtons) + 1);

  iAllButtonsWidth := iAllButtonsWidth +icInterspace*High(AButtons);

  if iAllButtonsWidth+icInterspace*2 > Frm.Width then
    Frm.Width := iAllButtonsWidth+icInterspace*2;

  if Length(Msg)>sizeof(Caption_ca) then
    SetLength(Msg,sizeof(Caption_ca));

  Lbl := TLabel.Create(Frm);
  Lbl.AutoSize := False;
  Lbl.Left := icInterspace*2+iIconWidth;
  Lbl.Top := icInterspace;
  Lbl.Height := 200;
  Lbl.Width := Frm.ClientWidth - icInterspace*3-iIconWidth;
  Lbl.WordWrap := True;
  Lbl.Caption := Msg;
  Lbl.Parent := Frm;

  if bCourier then
    lbl.Font.Name:='Courier New';

  Rect := Lbl.ClientRect;
  LabelText:=Lbl.Caption;
  StrPCopy(Caption_ca, LabelText);

  Lbl.Height:=DrawText(Lbl.Canvas.Handle,
                       Caption_ca,
                       Length(LabelText),
                       Rect,
                       DT_CalcRect or DT_ExpandTabs or DT_WordBreak Or DT_Left);


  If Lbl.Height<iIconHeight Then
    Lbl.Height:=iIconHeight;

  Frm.ClientHeight := Lbl.Height + 3*icInterspace + icButtonHeight;

  for I := 0 to High(AButtons) do
    begin
      Btn := TBitBtn.Create(Frm);
      Btn.Height := icButtonHeight;
      Btn.Width := iButtonWidth;
      Btn.Left:=((Frm.Width-iAllButtonsWidth) Div 2)+I*(iButtonWidth+icInterspace);
      Btn.Top := Frm.ClientHeight - Btn.height-icInterspace;
      Btn.Caption := AButtons[I];
      Btn.ModalResult := I + icButtonResultStart + icFirstButtonReturnValue;
      Btn.Parent := Frm;

      If I=DefBtn-1 Then
        Begin
          Frm.ActiveControl:=Btn;
          Btn.Default:=True;
        End
        Else
        Btn.Default:=False;

      If I=CanBtn-1 Then
        Btn.Cancel:=True
        Else
        Btn.Cancel:=False;
    end;

  Application.BringToFront;

  Result := Frm.ShowModal;

  If Result=mrCancel Then
    Result:=mrNone
    Else
    If Result>icButtonResultStart Then
      Result:=Result - icButtonResultStart
      Else
      Exception.Create('Unknown MessageDlgEx result');

  Frm.Free;
end;

procedure AutoSizeColsStringGrid(var StringGrid_AutoSize: TStringGrid);
var
  Integer_MaxWidth: Integer;
  Integer_Width: Integer;
  Byte_Col: Byte;
  Byte_Row: Byte;
begin
  for Byte_Col := 0 to StringGrid_AutoSize.ColCount - 1 do
  begin
    Integer_MaxWidth := 0;

    for Byte_Row := 0 to StringGrid_AutoSize.RowCount - 1 do
    begin
      Integer_Width := StringGrid_AutoSize.Canvas.TextWidth(StringGrid_AutoSize.Cells[Byte_Col, Byte_Row]);

      if Integer_Width > Integer_MaxWidth then
        Integer_MaxWidth := Integer_Width
    end;

    StringGrid_AutoSize.ColWidths[Byte_Col] := Integer_MaxWidth + 10;
  end;
end;}

end.
